import { render, staticRenderFns } from "./documentacion.vue?vue&type=template&id=5b320540&scoped=true"
import script from "./documentacion.vue?vue&type=script&lang=js"
export * from "./documentacion.vue?vue&type=script&lang=js"
import style0 from "./documentacion.vue?vue&type=style&index=0&id=5b320540&prod&lang=css"
import style1 from "./documentacion.vue?vue&type=style&index=1&id=5b320540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b320540",
  null
  
)

export default component.exports